import { Button, SvgExternalLink } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import * as analytics from 'utilities/analytics';

import UploadVideoImg from 'img/workspace-onboarding/upload-a-video.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import { showVideoUploadModal } from '../../../../../../actions/videoUploads';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { UPLOAD_VIDEO_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360007936997';

const UploadVideoCard = () => {
  const dispatch = useDispatch();

  const centerpiece = <img src={UploadVideoImg} />;

  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={() => {
        window.open(SUPPORT_ARTICLE_LINK);

        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'secondary',
          card: UPLOAD_VIDEO_CARD_KEY,
        });
      }}
    >
      Learn how
    </DashboardOnboardingSecondaryAction>
  );

  const primaryAction = (
    <Button
      onClick={() => {
        dispatch(showVideoUploadModal(true));

        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'primary',
          card: UPLOAD_VIDEO_CARD_KEY,
        });
      }}
    >
      Upload a video
    </Button>
  );

  return (
    <DashboardOnboardingCard
      cardKey={UPLOAD_VIDEO_CARD_KEY}
      heading="Upload a video"
      description="Already have a video? Upload a .wmv, .avi, .webm, .mp4 or .mov "
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="Success! Your video was uploaded."
    />
  );
};

export default UploadVideoCard;
